import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Accordion, Select, Tooltip } from '@cimpress/react-components';
import { toSelectOption } from 'src/util/misc';
import ErrorIcon from 'src/components/icons/ErrorIcon';

const EachSurfaceVariable = (props) => {
    const { configuration, removeConfiguration, updateConfiguration, documents, getErrorMessage } = props;

    const deleteConfiguration = () => removeConfiguration();

    const onConfigurationChangeHandler = (key, value) => {
        const newConfig = { ...configuration, [key]: value };
        const errorMessage = getErrorMessage(newConfig);
        updateConfiguration({ ...newConfig, errorMessage });
    };

    return (
        <Accordion
            className='product-variable-options-list'
            defaultOpen={true}
            title={
                <div className='layers-header' data-testid={`surface-variable-${configuration.variableAttribute}-item`}>
                    <div className='layers-header__text truncate_label' title={configuration.variableAttribute}>
                        {configuration.errorMessage && (
                            <Tooltip direction='top' contents={configuration.errorMessage}>
                                <ErrorIcon />
                            </Tooltip>
                        )}
                        {configuration.variableAttribute}
                    </div>
                    <button onClick={deleteConfiguration}>
                        <img className='iconLg' src='https://static.ux.cimpress.io/assets/icons/bin-1-f.svg' />
                    </button>
                </div>
            }>
            <div className='accordion-body-wrapper'>
                <p>
                    <b>Select All Customizable Area That Apply</b>
                </p>
                <div data-testid={`surface-variable-${configuration.variableAttribute}-document-selector`}>
                    <Select
                        options={toSelectOption(documents.map((doc) => doc.id))}
                        label='Select Document(s)'
                        value={
                            configuration.documents?.length > 0 ? toSelectOption(configuration.documents) : undefined
                        }
                        onChange={(chosenOption) =>
                            onConfigurationChangeHandler(
                                'documents',
                                chosenOption?.map((selected) => selected.value),
                            )
                        }
                        menuPortalTarget={document.body}
                        isMulti={true}
                    />
                </div>
            </div>
        </Accordion>
    );
};

EachSurfaceVariable.propTypes = {
    configuration: PropTypes.shape({
        variableAttribute: PropTypes.string,
        documents: PropTypes.arrayOf(PropTypes.string),
        values: PropTypes.arrayOf(PropTypes.any),
        isValid: PropTypes.bool,
        errorMessage: PropTypes.string,
    }),
    updateConfiguration: PropTypes.func.isRequired,
    removeConfiguration: PropTypes.func.isRequired,
    documents: PropTypes.arrayOf(PropTypes.any),
    getErrorMessage: PropTypes.func.isRequired,
};

export default connect()(EachSurfaceVariable);
